export default values => {
    const errors = {};
    const requiredFields = ["name", "url"];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });
    return errors;
};
